import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
// import Swal from 'sweetalert2';
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
// import TextField from '@material-ui/core/TextField';
import TextField, { Card } from "reactstrap";
import "react-notifications/lib/notifications.css";
import { Link } from "react-router-dom";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import {
  Col,
  Form,
  FormGroup,
  Row,
  Label,
  Input,
  Container,
  CardHeader,
  CardBody,
} from "reactstrap";
import LoadingOverlay from "react-loading-overlay";
import { fetchJSON } from "helpers/axios";

const CreateAlumniAccount = () => {
  // const history = useHistory();
  const [input, setInput] = useState({
    firstName: "",
    lastName: "",
    otherName: "",
    email: "",
    matricNo: "",
    password: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setInput({ ...input, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    const {
      firstName,
      lastName,
      email,
      matricNo,
      password,
      confirmPassword,
    } = input;

    if (
      !firstName ||
      !lastName ||
      !email ||
      !matricNo ||
      !password ||
      !confirmPassword
    ) {
      showAlert(
        "Validation Error",
        "Please fill in all required fields.",
        "error"
      );
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      showAlert(
        "Validation Error",
        "Please enter a valid email address.",
        "error"
      );
      return false;
    }

    if (password !== confirmPassword) {
      showAlert(
        "Validation Error",
        "Password and Confirm Password do not match.",
        "error"
      );
      return false;
    }

    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (validateForm()) {
      logInputValues();

      setLoading(true);
      try {
        const payload = {
          FirstName: input.firstName,
          LastName: input.lastName,
          OtherName: input.otherName,
          Email: input.email,
          MatricNo: input.matricNo,
          Password: input.password,
          ConfirmPassword: input.confirmPassword,
        };

        const response = await fetchJSON("api/SignUp", payload, "POST");
        const result = (await response?.Status) === "Ok";
        if (result) {
          setLoading(false);
          NotificationManager.success(response.Message);
          setInput({
            firstName: "",
            lastName: "",
            otherName: "",
            email: "",
            matricNo: "",
            password: "",
            confirmPassword: "",
          });

          setTimeout(() => {
            window.location.href = "/portal/alumniSignin";
            // history.push("/portal/alumniSignin");
          }, 1000);
        } else {
          setLoading(false);
          NotificationManager.warning(response.Message);
        }
      } catch (error) {
        setLoading(false);
        NotificationManager.error(error);
      }
    }
  };

  const logInputValues = () => {
    console.log("Form Input Values:", input);
  };

  return (
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{
        minHeight: "100vh",
      }}
    >
      <LoadingOverlay active={loading} spinner text="Loading...">
        <Card
          className="w-100 shadow"
          style={{
            maxWidth: "800px",
            borderRadius: "15px",
            backgroundColor: "rgba(255, 255, 255, 0.9)",
          }}
        >
          <CardHeader
            className="text-center text-white"
            style={{
              borderBottom: "1px solid rgba(0,0,0,0.1)",
              backgroundColor: "#540000",
            }}
          >
            <h2 className="mb-0">CREATE USER ACCOUNT</h2>
          </CardHeader>
          <CardBody className="p-4">
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label for="firstName">First Name</Label>
                    <Input
                      id="firstName"
                      name="firstName"
                      placeholder="Enter first name"
                      value={input.firstName}
                      onChange={handleChange}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label for="middleName">Middle Name</Label>
                    <Input
                      id="middleName"
                      name="otherName"
                      placeholder="Enter middle name"
                      value={input.otherName}
                      onChange={handleChange}
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label for="lastName">Last Name</Label>
                    <Input
                      id="lastName"
                      name="lastName"
                      placeholder="Enter last name"
                      value={input.lastName}
                      onChange={handleChange}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
              <FormGroup>
                <Label for="email">Email</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Enter email"
                  value={input.email}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label for="matricNo">Matric No</Label>
                <Input
                  id="matricNo"
                  name="matricNo"
                  placeholder="Enter matric number"
                  value={input.matricNo}
                  onChange={handleChange}
                  required
                />
                <small className="form-text text-danger" style={{ fontSize: "12px" }}>
                  If you have forgotten your matric number,{" "}
                  <a
                    href="./retrieveMatric"
                    className="text-danger"
                    style={{ textDecoration: "underline" }}
                  >
                    click here
                  </a>{" "}
                  to retrieve.
                </small>
              </FormGroup>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="password">Password</Label>
                    <Input
                      id="password"
                      name="password"
                      type="password"
                      placeholder="Enter password"
                      value={input.password}
                      onChange={handleChange}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="confirmPassword">Confirm Password</Label>
                    <Input
                      id="confirmPassword"
                      name="confirmPassword"
                      type="password"
                      placeholder="Confirm password"
                      value={input.confirmPassword}
                      onChange={handleChange}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
              <div className="d-flex flex-column align-items-center mt-4">
                <Button
                  type="submit"
                  style={{
                    backgroundColor: "#540000",
                    borderColor: "#540000",
                    width: "100%",
                  }}
                  className="text-white mb-3"
                  size="lg"
                  disabled={loading}
                >
                  {loading ? "Creating Account..." : "Create Account"}
                </Button>
                {/* <div className="w-100 d-flex align-items-center justify-content-between text-center">
                
                  <Link to="/alumniSignin" className="text-danger">
                    Back to Login
                  </Link>
                </div> */}
                <div className="text-center mt-3">
                  <p className="mb-0">
                    Already have an account?{" "}
                    <Link
                      to="/alumniSignin"
                      className="text-danger font-weight-bold"
                    >
                      Login
                    </Link>
                  </p>
                </div>
              </div>
            </Form>
          </CardBody>
        </Card>
      </LoadingOverlay>
      <NotificationContainer />
    </Container>
  );
};

export default CreateAlumniAccount;
